import React from 'react';
// eslint-disable-next-line import/no-unresolved
import map from 'images/products/mx_pcb_assembly/map.png';

const HowItWorks = () => (
  <>
    <div className="how-it-works">
      <div className="container">
        <div className="row no-gutters">
          <div className="col-12 col-lg-6">
            <h3 className="pt-3">How does it work?</h3>
            <ul>
              <li className="mb-3">All the material (PCBs and electronic components) are shipped to Calexico in the USA.</li>
              <li className="mb-3">The material is transported by land to Mexicali across the border.</li>
              <li className="mb-3">Your boards are assembled in Mexicali at a much lower cost.</li>
              <li className="mb-3">The assembled boards are transported back to Calixico and ship domestically to your location.</li>
            </ul>
          </div>
          <div className="col-12 col-lg-6 d-flex justify-content-center">
            <img src={map} alt="Calexico Map" className="img-fluid p-3" />
          </div>
        </div>
      </div>
    </div>
  </>
)

export default HowItWorks;
